declare namespace $ {

	type $mol_labeler__title_bog_gamengine_demo_shooter_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_gamengine_demo_shooter_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_labeler__title_bog_gamengine_demo_shooter_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_gamengine_demo_shooter_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_check_box__title_bog_gamengine_demo_shooter_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_bog_gamengine_demo_shooter_6 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['shadows'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__title_bog_gamengine_demo_shooter_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_bog_gamengine_demo_shooter_8 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['paused'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $bog_gamengine_draw__scene_bog_gamengine_demo_shooter_9 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Scene'] >
		,
		ReturnType< $bog_gamengine_draw['scene'] >
	>
	type $bog_gamengine_draw__cam_bog_gamengine_demo_shooter_10 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Eye'] >
		,
		ReturnType< $bog_gamengine_draw['cam'] >
	>
	type $bog_gamengine_draw__shadows_bog_gamengine_demo_shooter_11 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['shadows'] >
		,
		ReturnType< $bog_gamengine_draw['shadows'] >
	>
	type $bog_gamengine_draw__shadow_range_bog_gamengine_demo_shooter_12 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_draw['shadow_range'] >
	>
	type $bog_gamengine_draw__ambient_bog_gamengine_demo_shooter_13 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_draw['ambient'] >
	>
	type $bog_gamengine_draw__event_bog_gamengine_demo_shooter_14 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $bog_gamengine_demo_shooter['shoot'] > ): ReturnType< $bog_gamengine_demo_shooter['shoot'] >,
		}) 
		,
		ReturnType< $bog_gamengine_draw['event'] >
	>
	type $mol_view__sub_bog_gamengine_demo_shooter_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gamengine_demo_shooter_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_major__title_bog_gamengine_demo_shooter_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_gamengine_demo_shooter_18 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['restart'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_page__title_bog_gamengine_demo_shooter_19 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['end_title'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_bog_gamengine_demo_shooter_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_page__foot_bog_gamengine_demo_shooter_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['foot'] >
	>
	type $mol_view__sub_bog_gamengine_demo_shooter_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gamengine_demo_shooter_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gamengine_demo_shooter_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type __bog_gamengine_demo_shooter_25 = $mol_type_enforce<
		Parameters< $bog_gamengine_demo_shooter['paused'] >[0]
		,
		Parameters< ReturnType< $bog_gamengine_demo_shooter['Clock'] >['paused'] >[0]
	>
	type $bog_gamengine_shape_lines__points_bog_gamengine_demo_shooter_26 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['trace_points'] >
		,
		ReturnType< $bog_gamengine_shape_lines['points'] >
	>
	type $bog_gamengine_shape_lines__count_bog_gamengine_demo_shooter_27 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['trace_count'] >
		,
		ReturnType< $bog_gamengine_shape_lines['count'] >
	>
	type $bog_gamengine_shape_plane__tile_bog_gamengine_demo_shooter_28 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['floor_tile'] >
		,
		ReturnType< $bog_gamengine_shape_plane['tile'] >
	>
	type __bog_gamengine_demo_shooter_29 = $mol_type_enforce<
		Parameters< $bog_gamengine_demo_shooter['player_health'] >[0]
		,
		Parameters< ReturnType< $bog_gamengine_demo_shooter['Player'] >['health'] >[0]
	>
	type __bog_gamengine_demo_shooter_30 = $mol_type_enforce<
		Parameters< $bog_gamengine_demo_shooter['target_health'] >[0]
		,
		Parameters< $bog_gamengine_demo_shooter['Target'] >[0]
	>
	type __bog_gamengine_demo_shooter_31 = $mol_type_enforce<
		Parameters< $bog_gamengine_demo_shooter['target_health'] >[1]
		,
		Parameters< $bog_gamengine_demo_shooter['Target'] >[0]
	>
	type $bog_gamengine_demo_shooter_arena__map_bog_gamengine_demo_shooter_32 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['map'] >
		,
		ReturnType< $bog_gamengine_demo_shooter_arena['map'] >
	>
	type $bog_gamengine_atlas__uris_bog_gamengine_demo_shooter_33 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_gamengine_atlas['uris'] >
	>
	type $bog_gamengine_atlas__size_bog_gamengine_demo_shooter_34 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_atlas['size'] >
	>
	type $bog_gamengine_sound__listener_bog_gamengine_demo_shooter_35 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Eye'] >
		,
		ReturnType< $bog_gamengine_sound['listener'] >
	>
	type $bog_gamengine_sound__range_bog_gamengine_demo_shooter_36 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_sound['range'] >
	>
	type $bog_gamengine_sound__uris_bog_gamengine_demo_shooter_37 = $mol_type_enforce<
		({ 
			'shot': string,
			'hit': string,
		}) 
		,
		ReturnType< $bog_gamengine_sound['uris'] >
	>
	type $bog_gamengine_key__bind_bog_gamengine_demo_shooter_38 = $mol_type_enforce<
		({ 
			'forward': readonly(any)[],
			'back': readonly(any)[],
			'left': readonly(any)[],
			'right': readonly(any)[],
			'jump': readonly(any)[],
			'turn_left': readonly(any)[],
			'turn_right': readonly(any)[],
			'fire': readonly(any)[],
		}) 
		,
		ReturnType< $bog_gamengine_key['bind'] >
	>
	type $bog_gamengine_input__key_bog_gamengine_demo_shooter_39 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Key'] >
		,
		ReturnType< $bog_gamengine_input['key'] >
	>
	type $bog_gamengine_screen__target_bog_gamengine_demo_shooter_40 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['draw_node'] >
		,
		ReturnType< $bog_gamengine_screen['target'] >
	>
	type $bog_gamengine_scene__clock_bog_gamengine_demo_shooter_41 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Clock'] >
		,
		ReturnType< $bog_gamengine_scene['clock'] >
	>
	type $bog_gamengine_scene__input_bog_gamengine_demo_shooter_42 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Input'] >
		,
		ReturnType< $bog_gamengine_scene['input'] >
	>
	type $bog_gamengine_scene__kids_bog_gamengine_demo_shooter_43 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['nodes'] >
		,
		ReturnType< $bog_gamengine_scene['kids'] >
	>
	type $bog_gamengine_scene__phys3_bog_gamengine_demo_shooter_44 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Phys'] >
		,
		ReturnType< $bog_gamengine_scene['phys3'] >
	>
	type $bog_gamengine_scene__batches_bog_gamengine_demo_shooter_45 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['batches'] >
		,
		ReturnType< $bog_gamengine_scene['batches'] >
	>
	type $bog_gamengine_scene__cam_bog_gamengine_demo_shooter_46 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Eye'] >
		,
		ReturnType< $bog_gamengine_scene['cam'] >
	>
	type $bog_gamengine_scene__aspect_bog_gamengine_demo_shooter_47 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['aspect'] >
		,
		ReturnType< $bog_gamengine_scene['aspect'] >
	>
	type $bog_gamengine_scene__Shader_solid_bog_gamengine_demo_shooter_48 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Solid'] >
		,
		ReturnType< $bog_gamengine_scene['Shader_solid'] >
	>
	type $bog_gamengine_batch__shader_bog_gamengine_demo_shooter_49 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Solid'] >
		,
		ReturnType< $bog_gamengine_batch['shader'] >
	>
	type $bog_gamengine_batch__shape_bog_gamengine_demo_shooter_50 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Box'] >
		,
		ReturnType< $bog_gamengine_batch['shape'] >
	>
	type $bog_gamengine_batch__atlas_bog_gamengine_demo_shooter_51 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Atlas'] >
		,
		ReturnType< $bog_gamengine_batch['atlas'] >
	>
	type $bog_gamengine_batch__source_bog_gamengine_demo_shooter_52 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Phys'] >
		,
		ReturnType< $bog_gamengine_batch['source'] >
	>
	type $bog_gamengine_batch__skip_bog_gamengine_demo_shooter_53 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_batch['skip'] >
	>
	type $bog_gamengine_batch__shader_bog_gamengine_demo_shooter_54 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Flat'] >
		,
		ReturnType< $bog_gamengine_batch['shader'] >
	>
	type $bog_gamengine_batch__shape_bog_gamengine_demo_shooter_55 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Lines'] >
		,
		ReturnType< $bog_gamengine_batch['shape'] >
	>
	type $bog_gamengine_batch__instances_bog_gamengine_demo_shooter_56 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_batch['instances'] >
	>
	type $bog_gamengine_particle_pool__cap_bog_gamengine_demo_shooter_57 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_particle_pool['cap'] >
	>
	type $bog_gamengine_particle__pool_bog_gamengine_demo_shooter_58 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Spark_pool'] >
		,
		ReturnType< $bog_gamengine_particle['pool'] >
	>
	type $bog_gamengine_particle__atlas_bog_gamengine_demo_shooter_59 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Atlas'] >
		,
		ReturnType< $bog_gamengine_particle['atlas'] >
	>
	type $bog_gamengine_particle__frame_bog_gamengine_demo_shooter_60 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_particle['frame'] >
	>
	type $bog_gamengine_particle__life_bog_gamengine_demo_shooter_61 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['spark_life'] >
		,
		ReturnType< $bog_gamengine_particle['life'] >
	>
	type $bog_gamengine_particle__speed_bog_gamengine_demo_shooter_62 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['spark_speed'] >
		,
		ReturnType< $bog_gamengine_particle['speed'] >
	>
	type $bog_gamengine_particle__spread_bog_gamengine_demo_shooter_63 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_particle['spread'] >
	>
	type $bog_gamengine_particle__size_bog_gamengine_demo_shooter_64 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['spark_size'] >
		,
		ReturnType< $bog_gamengine_particle['size'] >
	>
	type $bog_gamengine_particle__color_bog_gamengine_demo_shooter_65 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['spark_color'] >
		,
		ReturnType< $bog_gamengine_particle['color'] >
	>
	type $bog_gamengine_particle__billboard_bog_gamengine_demo_shooter_66 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_particle['billboard'] >
	>
	type $bog_gamengine_mesh__shape_bog_gamengine_demo_shooter_67 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Plane'] >
		,
		ReturnType< $bog_gamengine_mesh['shape'] >
	>
	type $bog_gamengine_mesh__atlas_bog_gamengine_demo_shooter_68 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Atlas'] >
		,
		ReturnType< $bog_gamengine_mesh['atlas'] >
	>
	type $bog_gamengine_mesh__frame_bog_gamengine_demo_shooter_69 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_mesh['frame'] >
	>
	type $bog_gamengine_mesh__pos_bog_gamengine_demo_shooter_70 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['floor_pos'] >
		,
		ReturnType< $bog_gamengine_mesh['pos'] >
	>
	type $bog_gamengine_mesh__size_bog_gamengine_demo_shooter_71 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['floor_size'] >
		,
		ReturnType< $bog_gamengine_mesh['size'] >
	>
	type $bog_gamengine_demo_shooter_player__phys3_bog_gamengine_demo_shooter_72 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Phys'] >
		,
		ReturnType< $bog_gamengine_demo_shooter_player['phys3'] >
	>
	type $bog_gamengine_demo_shooter_player__input_bog_gamengine_demo_shooter_73 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Input'] >
		,
		ReturnType< $bog_gamengine_demo_shooter_player['input'] >
	>
	type $bog_gamengine_demo_shooter_player__screen_bog_gamengine_demo_shooter_74 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Screen'] >
		,
		ReturnType< $bog_gamengine_demo_shooter_player['screen'] >
	>
	type $bog_gamengine_demo_shooter_player__sound_bog_gamengine_demo_shooter_75 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Sound'] >
		,
		ReturnType< $bog_gamengine_demo_shooter_player['sound'] >
	>
	type $bog_gamengine_demo_shooter_player__spark_bog_gamengine_demo_shooter_76 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Spark'] >
		,
		ReturnType< $bog_gamengine_demo_shooter_player['spark'] >
	>
	type $bog_gamengine_demo_shooter_player__targets_bog_gamengine_demo_shooter_77 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['targets'] >
		,
		ReturnType< $bog_gamengine_demo_shooter_player['targets'] >
	>
	type $bog_gamengine_demo_shooter_player__height_bog_gamengine_demo_shooter_78 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['player_height'] >
		,
		ReturnType< $bog_gamengine_demo_shooter_player['height'] >
	>
	type $bog_gamengine_demo_shooter_player__radius_bog_gamengine_demo_shooter_79 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_demo_shooter_player['radius'] >
	>
	type $bog_gamengine_demo_shooter_player__speed_bog_gamengine_demo_shooter_80 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_demo_shooter_player['speed'] >
	>
	type $bog_gamengine_demo_shooter_player__jump_bog_gamengine_demo_shooter_81 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_demo_shooter_player['jump'] >
	>
	type $bog_gamengine_demo_shooter_player__pos_bog_gamengine_demo_shooter_82 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['player_pos'] >
		,
		ReturnType< $bog_gamengine_demo_shooter_player['pos'] >
	>
	type $bog_gamengine_cam_deep__follow_bog_gamengine_demo_shooter_83 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Player'] >
		,
		ReturnType< $bog_gamengine_cam_deep['follow'] >
	>
	type $bog_gamengine_cam_deep__lift_bog_gamengine_demo_shooter_84 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['eye_lift'] >
		,
		ReturnType< $bog_gamengine_cam_deep['lift'] >
	>
	type $bog_gamengine_cam_deep__far_bog_gamengine_demo_shooter_85 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_cam_deep['far'] >
	>
	type $bog_gamengine_demo_shooter_target__phys3_bog_gamengine_demo_shooter_86 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Phys'] >
		,
		ReturnType< $bog_gamengine_demo_shooter_target['phys3'] >
	>
	type $bog_gamengine_demo_shooter_target__player_bog_gamengine_demo_shooter_87 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Player'] >
		,
		ReturnType< $bog_gamengine_demo_shooter_target['player'] >
	>
	type $bog_gamengine_demo_shooter_target__sound_bog_gamengine_demo_shooter_88 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Sound'] >
		,
		ReturnType< $bog_gamengine_demo_shooter_target['sound'] >
	>
	type $bog_gamengine_demo_shooter_target__layer_bog_gamengine_demo_shooter_89 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['target_layer'] >
		,
		ReturnType< $bog_gamengine_demo_shooter_target['layer'] >
	>
	type $bog_gamengine_demo_shooter_target__start_bog_gamengine_demo_shooter_90 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['target_start'] >
		,
		ReturnType< $bog_gamengine_demo_shooter_target['start'] >
	>
	type $bog_gamengine_light__kind_bog_gamengine_demo_shooter_91 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_light['kind'] >
	>
	type $bog_gamengine_light__rot_bog_gamengine_demo_shooter_92 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['sun_rot'] >
		,
		ReturnType< $bog_gamengine_light['rot'] >
	>
	type $bog_gamengine_light__power_bog_gamengine_demo_shooter_93 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_light['power'] >
	>
	type $bog_gamengine_light__kind_bog_gamengine_demo_shooter_94 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_light['kind'] >
	>
	type $bog_gamengine_light__parent_bog_gamengine_demo_shooter_95 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_shooter['Eye'] >
		,
		ReturnType< $bog_gamengine_light['parent'] >
	>
	type $bog_gamengine_light__power_bog_gamengine_demo_shooter_96 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_light['power'] >
	>
	type $bog_gamengine_light__range_bog_gamengine_demo_shooter_97 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_light['range'] >
	>
	type $bog_gamengine_light__angle_bog_gamengine_demo_shooter_98 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_light['angle'] >
	>
	export class $bog_gamengine_demo_shooter extends $mol_page {
		health_stat( ): string
		Health( ): $mol_labeler
		targets_stat( ): string
		Targets( ): $mol_labeler
		shadows( next?: boolean ): boolean
		Shadows( ): $mol_check_box
		Pause( ): $mol_check_box
		stat( ): ReturnType< ReturnType< $bog_gamengine_demo_shooter['Draw'] >['stat'] >
		shoot( next?: any ): any
		Draw( ): $bog_gamengine_draw
		Cross_bar( ): $mol_view
		Cross_pin( ): $mol_view
		Cross( ): $mol_view
		end_title( ): string
		end_hint( ): string
		End_hint( ): $mol_view
		restart( next?: any ): any
		Again( ): $mol_button_major
		End( ): $mol_page
		game( ): readonly(any)[]
		player_stat( ): string
		Player_stat( ): $mol_view
		Stat( ): $mol_view
		phys_stat( ): string
		Phys_stat( ): $mol_view
		draw_node( ): any
		paused( next?: ReturnType< ReturnType< $bog_gamengine_demo_shooter['Clock'] >['paused'] > ): ReturnType< ReturnType< $bog_gamengine_demo_shooter['Clock'] >['paused'] >
		nodes( ): readonly(any)[]
		batches( ): readonly(any)[]
		aspect( ): number
		Solid( ): $bog_gamengine_shader_solid
		Box( ): $bog_gamengine_shape_box
		Flat( ): $bog_gamengine_shader_flat
		trace_points( ): Float32Array
		trace_count( ): number
		Lines( ): $bog_gamengine_shape_lines
		spark_life( ): Float32Array
		spark_speed( ): Float32Array
		spark_size( ): Float32Array
		spark_color( ): Float32Array
		floor_tile( ): Float32Array
		Plane( ): $bog_gamengine_shape_plane
		floor_pos( ): Float32Array
		floor_size( ): Float32Array
		targets( ): readonly(any)[]
		player_height( ): number
		player_pos( next?: Float32Array ): Float32Array
		player_health( next?: ReturnType< ReturnType< $bog_gamengine_demo_shooter['Player'] >['health'] > ): ReturnType< ReturnType< $bog_gamengine_demo_shooter['Player'] >['health'] >
		eye_lift( ): number
		target_layer( ): number
		target_start( id: any): Float32Array
		target_health( id: any, next?: ReturnType< ReturnType< $bog_gamengine_demo_shooter['Target'] >['health'] > ): ReturnType< ReturnType< $bog_gamengine_demo_shooter['Target'] >['health'] >
		sun_rot( ): Float32Array
		title( ): string
		tools( ): readonly(any)[]
		body( ): ReturnType< $bog_gamengine_demo_shooter['game'] >
		foot( ): readonly(any)[]
		round( next?: number ): number
		map( ): string
		Phys( ): $bog_gamengine_demo_shooter_phys
		Arena( ): $bog_gamengine_demo_shooter_arena
		Atlas( ): $bog_gamengine_atlas
		Sound( ): $bog_gamengine_sound
		Key( ): $bog_gamengine_key
		Input( ): $bog_gamengine_input
		Screen( ): $bog_gamengine_screen
		Clock( ): $bog_gamengine_clock
		Scene( ): $bog_gamengine_scene
		Solids( ): $bog_gamengine_batch
		Traces( ): $bog_gamengine_batch
		Spark_pool( ): $bog_gamengine_particle_pool
		Spark( ): $bog_gamengine_particle
		Floor( ): $bog_gamengine_mesh
		Player( ): $bog_gamengine_demo_shooter_player
		Eye( ): $bog_gamengine_cam_deep
		Target( id: any): $bog_gamengine_demo_shooter_target
		Sun( ): $bog_gamengine_light
		Lamp( ): $bog_gamengine_light
	}
	
}

//# sourceMappingURL=shooter.view.tree.d.ts.map